import { RHFTextField, Section } from "@arp/react-ndbx";
import { Typography } from "@mui/material";
import React from "react";

function AuraBloodPressure({ mappedContent }) {
  return (
    <Section>
      {mappedContent.context && (
        <Section mb={3}>
          <Typography
            mb={4}
            sx={{
              width: "fit-content !important",
            }}
            variant="label-large-bold"
          >
            {mappedContent.context}
          </Typography>
        </Section>
      )}
      {mappedContent.statement && (
        <Typography
          sx={{
            marginBottom: 5 / 2,
            display: "flex",
          }}
          variant="label-large-bold"
        >
          {mappedContent.statement}
        </Typography>
      )}
      <Typography
        sx={{
          marginBottom: 4,
        }}
        variant="label-large-bold"
        dangerouslySetInnerHTML={{ __html: mappedContent.richText }}
      ></Typography>
      <Section md={6} sx={{ display: "flex", justifyContent: "space-between" }}>
        <Section md={6}>
          <RHFTextField
            name="systolicReading"
            className="subvariant-text-input"
            variant="standard"
            label="Systolic"
            sx={{ textTransform: "uppercase" }}
            type="number"
          />
        </Section>
        <Section md={6} sx={{ marginLeft: 3 }}>
          <RHFTextField
            name="diastolicReading"
            className="subvariant-text-input"
            variant="standard"
            label="Diastolic"
            sx={{ textTransform: "uppercase" }}
            type="number"
          />
        </Section>
      </Section>
    </Section>
  );
}

export default AuraBloodPressure;
